<template>
  <div>
    <div class="bg-secondary text-white px-4 py-5 position-relative">
      <div v-background="require('@/assets/photo-header.jpg')" class="header-background"/>
      <div class="container my-2">
        <div class="row">
          <div class="col-9">
            <h1>Bienvenue sur l'espace de réservation hôtelière pour le SPACE 2024</h1>
            <p class="mt-3">Welcome to the hotel booking website for SPACE 2024</p>
          </div>
        </div>
      </div>
    </div>
    <div v-background="require('@/assets/white_plaster.png')" class="px-4 py-5">
      <div class="container text-secondary">
        <h2>Votre demande de réservation a été effectuée !</h2>
        <p
          v-if="booking.contact"
        >Vous recevrez un mail de confirmation à l'adresse {{booking.contact.email}}.</p>
        <router-link
          tag="button"
          to="/"
          class="btn btn-primary"
          exact
        >Faire une nouvelle réservation</router-link>
      </div>
    </div>
    <div class="px-4 py-5">
      <div class="container text-secondary">
        <h3
          v-if="booking.period"
        >Résumé de votre réservation du {{booking.period.from | date}} au {{booking.period.until | date}}</h3>
        <div class="row bg-light py-2">
          <div class="col-3">
            <strong>Hôtel</strong>
          </div>
          <div class="col-3">
            <strong>Type de chambre</strong>
          </div>
          <div class="col-2">
            <strong>Quantité</strong>
          </div>
          <div class="col-2">
            <strong>Occupant(s)</strong>
          </div>
          <div class="col-2"></div>
        </div>
        <div
          class="row py-3"
          v-for="(rangeBooking, rangeBookingIndex) in booking.rangeBookings"
          :key="rangeBookingIndex"
        >
          <div class="col-3">{{rangeBooking.place.name}}</div>
          <div class="col-3">{{rangeBooking.room.name}}</div>
          <div class="col-2">{{rangeBooking.quantity}}</div>
          <div class="col-2">{{rangeBooking.persons}}</div>
          <div class="col-2"></div>
        </div>
        <div class="row bg-secondary text-white py-2">
          <div class="col-6 text-right">
            <strong>Total</strong>
          </div>
          <div class="col-2">
            <strong>{{booking.total.rooms}}</strong>
          </div>
          <div class="col-2">
            <strong>{{booking.total.persons}}</strong>
          </div>
          <div class="col-2">
            <strong>{{booking.total.price}}€</strong>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
export default {
  name: "BookingDone",

  filters: {
    date(input) {
      return moment(input, "YYYY-MM-DD").format("LL");
    }
  },

  firestore() {
    return {
      booking: this.$db.collection("bookings").doc(this.$route.params.bookingId)
    };
  }
};
</script>